import React from 'react';
import { useTranslation } from 'react-i18next';

const VIDEOS = {
    fr: {
        search: 'https://www.youtube.com/watch?v=zV47Pb4JJlo',
        ai: 'https://www.youtube.com/watch?v=6hc_XYe27WY',
    },
    ar: {
        search: 'https://www.youtube.com/watch?v=cXNXh3xmMkY&t=149s',
        ai: 'https://www.youtube.com/watch?v=N77GWkE5bBE',
    },
};

const Help: React.FC = () => {
    const { t, i18n } = useTranslation();
    const lang: 'fr' | 'ar' = i18n.language?.startsWith('ar') ? 'ar' : 'fr';
    const videos = VIDEOS[lang];

    return (
        <div className="container mt-5">
            <h1>{t('help.title')}</h1>
            <p>{t('help.description')}</p>

            <ul className="list-unstyled mt-4">
                <li className="mb-2">
                    <i className="fa-brands fa-youtube text-danger me-2"></i>
                    <a href={videos.search} target="_blank" rel="noopener noreferrer">
                        {t('help.videos.search')}
                    </a>
                </li>
                <li className="mb-2">
                    <i className="fa-brands fa-youtube text-danger me-2"></i>
                    <a href={videos.ai} target="_blank" rel="noopener noreferrer">
                        {t('help.videos.ai')}
                    </a>
                </li>
            </ul>
        </div>
    );
};

export default Help;
